










































































































































import Vue from "vue";
import Component from "vue-class-component";
import store from "../core/store";
import { SettingsService } from "../core/services/configService";
import { ProgramPackTexts } from "../bookings/programPackTexts";
import { GuidelineApi, DayDone } from "../components/guidelines/guidelineApi";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramMedia from "../components/programs/ProgramMedia.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzChip from "../components/cz/CzChip.vue";
import CzTitle from "../components/cz/CzTitle.vue";
import CzNotice from "../components/cz/CzNotice.vue";
import CzSegmented from "../components/cz/CzSegmented.vue";
import CzStatus from "../components/cz/CzStatus.vue";
import CzIcon from "../components/cz/CzIcon.vue";
import CzLink from "../components/cz/CzLink.vue";
import GuidelineSessionContent from "../components/guidelines/GuidelineSessionContent.vue";
import GuidelineSubmission from "../components/guidelines/GuidelineSubmission.vue";
import GuidelineSessionList from "../components/guidelines/GuidelineSessionList.vue";
import GuidelineChat from "../components/guidelines/GuidelineChat.vue";
import { submissionState } from "../components/guidelines/submissionState";
import CzButton from "../components/cz/CzButton.vue";

const AskVideo = 1;
const TurnDue = 0;
const TurnFree = 1;
const TurnWeekDone = 2;

// The guideline: on top its week, when the next one is, what is pending to send and the button to start today's
// session; below, tabs for the sessions, the information and the messages. A session opens on its own, with the bar to
// mark it and, once done, what to send. With ?preview the admin sees the template as the customer will.
@Component({
  watch: {
    "$route.query.answer"() {
      window.scrollTo(0, 0);
    },
    "$route.query.session"() {
      (this as any).justDone = false;
      (this as any).answeredId = -1;
      window.scrollTo(0, 0);
    },
  },
  components: { ProgramPage, ProgramMedia, CzCard, CzChip, CzTitle, CzNotice, CzSegmented, CzStatus, CzIcon, CzLink, CzButton, GuidelineSessionContent, GuidelineSubmission, GuidelineSessionList, GuidelineChat },
})
export default class GuidelinePage extends Vue {
  d: any = null;
  loaded: boolean = false;
  slots: any[] = [];
  submissions: any[] = [];
  canMessage = false;
  hasMessages = false;
  justDone = false;
  // The place sent right after "Done" stays on screen until it is ready or rejected; -1 = none yet.
  answeredId: number | null = -1;
  weekOffset: number = 0;
  otherDay = false;
  busy: boolean = false;
  error: string = "";
  failed: (() => Promise<void>) | null = null;

  get previewToken(): string {
    return (this.$route.query.preview as string) || "";
  }

  get backTo(): any {
    if (this.d && (this.openSession || this.answeringWhole || this.readingRetired)) {
      const query = Object.assign({}, this.$route.query);
      delete query.session;
      delete query.answer;
      delete query.retired;
      return { path: this.$route.path, query: query };
    }
    if (this.previewToken) return "";
    return (this.$route.query.back as string) || "/today";
  }

  get backLabel(): string {
    if (this.d && (this.openSession || this.answeringWhole || this.readingRetired)) return this.d.name;
    const back = (this.$route.query.back as string) || "";
    if (back.startsWith("/customer-programs")) return this.$t("Your program").toString();
    if (back.startsWith("/guidelines")) return this.$t("Your guidelines").toString();
    return back && back !== "/today" ? this.$t("Back").toString() : this.$t("Today").toString();
  }

  get emptyText(): string {
    return this.loaded && !this.d ? this.$t("This guideline is not available").toString() : "";
  }

  get today(): string {
    return GuidelineApi.day(this.d.today);
  }

  get facts(): string {
    const bits: string[] = [];
    if (this.d.estimatedMinutes) bits.push(this.$t("about {0} min").toString().replace("{0}", this.d.estimatedMinutes));
    if (this.d.row) {
      bits.push(this.timesPerWeek(this.d.row.timesPerWeek));
    }
    if (this.d.endDate) bits.push(this.$t("until {0}").toString().replace("{0}", ProgramPackTexts.date(GuidelineApi.addDays(GuidelineApi.day(this.d.endDate), -1) + "T12:00:00", false)));
    return bits.join(" · ");
  }

  get monday(): string {
    return GuidelineApi.addDays(GuidelineApi.mondayOf(this.today), 7 * this.weekOffset);
  }

  get canGoBack(): boolean {
    return this.monday > GuidelineApi.mondayOf(GuidelineApi.day(this.d.startDate));
  }

  get weekLabel(): string {
    return this.$t("Week of {0}").toString().replace("{0}", ProgramPackTexts.date(this.monday + "T12:00:00", false));
  }

  get meta(): string {
    return [this.d.category, this.facts].filter((x: string) => !!x).join(" · ");
  }

  // What the patient does now: today's session, or the next one and from when.
  get now(): any {
    const numbered = (x: any) => (x ? this.d.sessions.indexOf(x) + 1 + " · " + x.title : "");
    if (this.canRecordToday && this.todayStatus === null && this.canDoToday) {
      const due = this.d.turn.kind === TurnDue;
      return { label: (due ? this.$t("Today it's your turn") : this.$t("The next one")).toString(), title: numbered(this.todaySession) };
    }
    if (!this.d.turn) return null;
    return { label: this.$t("The next one").toString(), title: numbered(this.nextSession) };
  }

  get doneTodayText(): string {
    const record = this.d.days.find((x: any) => GuidelineApi.day(x.date) === this.today);
    const s = record && this.d.sessions.find((x: any) => x.id === record.guidelineSessionId);
    return s ? this.$t("Done today: {0}").toString().replace("{0}", this.d.sessions.indexOf(s) + 1 + " · " + s.title) : this.$t("Done today").toString();
  }

  // "1 of 3 days" and when, without repeating "today" when the label already says it.
  get progressText(): string {
    const turn = this.now && this.now.label === this.yourTurn ? "" : this.yourTurn;
    return [this.weekSummary, turn].filter((x) => !!x).join(" · ");
  }

  get currentWeek(): any {
    return this.d.weeks.find((w: any) => GuidelineApi.day(w.monday) === GuidelineApi.mondayOf(this.today));
  }

  get weekSummary(): string {
    const week = this.currentWeek;
    if (!week) return "";
    if (week.closed) return this.$t("closed").toString();
    return this.$t("{0} of {1} days").toString().replace("{0}", String(Math.min(week.done, week.target))).replace("{1}", week.target);
  }

  // One mark per time the week asks for, filled with what is done: the days are free, only the count matters.
  get currentSlots(): boolean[] {
    const week = this.currentWeek;
    if (!week || week.closed) return [];
    return Array.from({ length: week.target }, (_, i) => i < week.done);
  }

  get strip(): any[] {
    const name = new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long", day: "numeric" });
    const short = new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "narrow" });
    const from = GuidelineApi.day(this.d.recordFrom);
    const to = GuidelineApi.day(this.d.recordTo);
    return [0, 1, 2, 3, 4, 5, 6].map((i) => {
      const date = GuidelineApi.addDays(this.monday, i);
      const record = this.d.days.find((x: any) => GuidelineApi.day(x.date) === date);
      const status = record ? record.status : null;
      const label = name.format(new Date(date + "T12:00:00"));
      const state = status === 0 ? this.$t("done").toString() : status === 1 ? this.$t("you could not").toString() : this.$t("not recorded").toString();
      return {
        date: date,
        isToday: date === this.today,
        name: date === this.today ? this.$t("Today").toString() : short.format(new Date(date + "T12:00:00")) + " " + Number(date.substring(8)),
        status: status,
        letter: status === 0 ? "✓" : status === 1 ? "–" : "",
        editable: date < this.today && date >= from && date <= to,
        aria: label + ", " + state,
      };
    });
  }

  get canRecordPast(): boolean {
    return this.strip.some((day: any) => day.editable);
  }

  get canRecordToday(): boolean {
    return !this.previewToken && !!this.d && GuidelineApi.day(this.d.recordTo) === this.today && GuidelineApi.day(this.d.recordFrom) <= this.today;
  }

  // The bar records today's session: only on it, and not once it shows what to send.
  get showBar(): boolean {
    return this.canRecordToday && !!this.openSession && this.openSession === this.todaySession && !this.justDone;
  }

  get tabs(): any[] {
    const tabs: any[] = [];
    if (this.sessionRows.length) tabs.push({ value: "sessions", label: this.$t("Sessions").toString() });
    tabs.push({ value: "info", label: this.$t("Information").toString() });
    if (this.canMessage || this.hasMessages) tabs.push({ value: "messages", label: this.$t("Messages").toString() });
    return tabs;
  }

  // In the address, so going back from a session lands on the same tab.
  get tab(): string {
    const asked = this.$route.query.tab as string;
    return this.tabs.some((t: any) => t.value === asked) ? asked : this.tabs[0].value;
  }

  set tab(value: string) {
    this.$router.replace({ path: this.$route.path, query: Object.assign({}, this.$route.query, { tab: value }) });
  }

  get sessionRows(): any[] {
    const rows = this.d.sessions.map((s: any, i: number) => ({
      id: s.id,
      number: i + 1,
      title: s.title,
      to: this.sessionLink(s),
      state: this.sessionState(s),
      accent: s === this.todaySession && this.todayStatus === null,
      chip: submissionState(this.place(s.id), (k) => this.$t(k).toString()),
    }));
    // A session taken out of the guideline stays while it has something sent: to read it and its correction.
    for (const r of this.slots.filter((x: any) => x.retired)) {
      const chip = submissionState(r, (k) => this.$t(k).toString());
      rows.push({
        id: r.sessionId,
        number: 0,
        title: r.title,
        to: { path: this.$route.path, query: Object.assign({}, this.$route.query, { retired: String(r.sessionId) }) },
        state: this.$t("Removed from the guideline").toString(),
        accent: false,
        chip: chip && !chip.act ? chip : null,
      });
    }
    // What the whole guideline asks for is one more step: shown from the start, open once the guideline is over.
    const whole = this.slots.find((x: any) => !x.sessionId);
    if (whole) {
      const open = !!this.place(null);
      rows.push({
        id: 0,
        number: this.d.sessions.length + 1,
        title: whole.kind === AskVideo ? this.$t("Send a video").toString() : this.$t("Send a photo").toString(),
        to: open ? this.wholeLink : "",
        locked: !open,
        state: open ? "" : this.$t("When you finish the guideline").toString(),
        accent: false,
        chip: submissionState(this.place(null), (k) => this.$t(k).toString()),
      });
    }
    return rows;
  }

  // The first thing the patient has to send (a session in order, then the whole guideline), shown on top.
  get pending(): any {
    const t = (k: string) => this.$t(k).toString();
    for (const s of this.d.sessions) {
      const state = submissionState(this.place(s.id), t);
      if (state && state.act) return { text: state.text, tone: state.tone, where: s.title, to: this.sessionLink(s) };
    }
    const whole = submissionState(this.place(null), t);
    if (whole && whole.act) return { text: whole.text, tone: whole.tone, where: this.$t("When you finish the guideline").toString(), to: this.wholeLink };
    return null;
  }

  get sessionStep(): string {
    const n = this.d.sessions.indexOf(this.openSession) + 1;
    return this.$t("Session {0} of {1}").toString().replace("{0}", String(n)).replace("{1}", String(this.d.sessions.length));
  }

  // What was already sent for the open session goes first: its review is what the patient comes for.
  get sessionSent(): boolean {
    const p = this.place(this.openSession.id);
    return !!p && !!p.submission;
  }

  // Right after "Done": what the session asks to send, or the whole guideline's if that was its last day.
  get answerPlace(): any {
    if (this.answeredId !== -1) return this.place(this.answeredId);
    const own = this.place(this.openSession.id);
    if (own && own.canSend) return own;
    const whole = this.place(null);
    return whole && whole.canSend ? whole : null;
  }

  answered(p: any) {
    this.answeredId = p.sessionId || null;
    return this.loadSubmissions();
  }

  get todayStatus(): number | null {
    const record = this.d.days.find((x: any) => GuidelineApi.day(x.date) === this.today);
    return record ? record.status : null;
  }

  get todaySession(): any {
    if (this.previewToken || !this.canRecordToday) return null;
    if (this.todayStatus === 0) {
      const record = this.d.days.find((x: any) => GuidelineApi.day(x.date) === this.today);
      return this.d.sessions.find((x: any) => x.id === record.guidelineSessionId) || null;
    }
    return this.todayStatus === null && this.canDoToday ? this.nextSession : null;
  }

  // Today is a day to do it only while the week still asks for more (GuidelineProgress.Turn): with the week met,
  // "today" is not offered again.
  get canDoToday(): boolean {
    const t = this.d.turn;
    return !!t && (t.kind === TurnFree || (t.kind === TurnDue && GuidelineApi.day(t.date) === this.today));
  }

  get nextSession(): any {
    return this.d.sessions.find((s: any) => s.isNext) || null;
  }

  get noteBy(): string {
    return this.d.professionalName ? this.$t("{0} tells you").toString().replace("{0}", this.d.professionalName) : this.$t("Your professional tells you").toString();
  }

  timesPerWeek(n: number): string {
    if (n === 7) return this.$t("every day").toString();
    if (n === 1) return this.$t("once a week").toString();
    return this.$t("{0} days a week").toString().replace("{0}", String(n));
  }

  get openSession(): any {
    const asked = this.$route.query.session;
    if (!asked || !this.d.sessions.length) return null;
    if (asked === "next") return this.todaySession;
    return this.d.sessions.find((s: any) => s.id === Number(asked)) || null;
  }

  get readingRetired(): any {
    const asked = Number(this.$route.query.retired);
    return asked ? this.slots.find((x: any) => x.retired && x.sessionId === asked) || null : null;
  }

  // What the whole guideline asks to send, on a screen of its own.
  get answeringWhole(): boolean {
    return this.$route.query.answer === "whole" && !!this.place(null);
  }

  get wholeLink(): any {
    return { path: this.$route.path, query: Object.assign({}, this.$route.query, { answer: "whole" }) };
  }

  sessionLink(session: any): any {
    return { path: this.$route.path, query: Object.assign({}, this.$route.query, { session: String(session.id) }) };
  }

  sessionState(s: any): string {
    if (this.previewToken) return "";
    if (s === this.todaySession) {
      if (this.todayStatus === 0) return this.$t("Done today").toString();
      return (this.d.turn && this.d.turn.kind === TurnDue ? this.$t("Today it's your turn") : this.$t("The next one")).toString();
    }
    // Sessions go round in a loop: the next one may be one already done, so both are said.
    const done = this.d.days.filter((x: any) => x.status === DayDone && x.guidelineSessionId === s.id).map((x: any) => GuidelineApi.day(x.date)).sort();
    const last = done.length ? this.$t("Done on {0}").toString().replace("{0}", ProgramPackTexts.date(done[done.length - 1] + "T12:00:00", false)) : "";
    if (!s.isNext || !this.d.nextDate) return last;
    return last ? last + "\n" + this.nextDateText(true) : this.nextDateText(false);
  }

  // Days are free: "today" or "tomorrow" only when the days left in the week are just enough (GuidelineProgress.Turn).
  get yourTurn(): string {
    const t = this.d.turn;
    if (!t) return "";
    if (t.kind === TurnFree) {
      const until = this.weekday(GuidelineApi.day(t.until));
      return t.remaining === 1
        ? this.$t("You have 1 left this week, until {0}").toString().replace("{0}", until)
        : this.$t("You have {0} left this week, until {1}").toString().replace("{0}", t.remaining).replace("{1}", until);
    }
    const date = GuidelineApi.day(t.date);
    const when = date === this.today ? this.$t("Today it's your turn").toString()
      : date === GuidelineApi.addDays(this.today, 1) ? this.$t("Your turn tomorrow").toString()
      : this.$t("Your turn on {0}").toString().replace("{0}", this.dayAndDate(date));
    return t.kind === TurnWeekDone ? this.$t("Week completed").toString() + " · " + when : when;
  }

  weekday(day: string): string {
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long" }).format(new Date(day + "T12:00:00"));
  }

  dayAndDate(day: string): string {
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long", day: "numeric", month: "short" }).format(new Date(day + "T12:00:00"));
  }

  nextDateText(again: boolean): string {
    const next = GuidelineApi.day(this.d.nextDate);
    const date = ProgramPackTexts.date(next + "T12:00:00", false);
    if (next === GuidelineApi.addDays(this.today, 1)) return again ? this.$t("Next time, from tomorrow").toString() : this.$t("From tomorrow").toString();
    return (again ? this.$t("Next time, from {0}") : this.$t("From {0}")).toString().replace("{0}", date);
  }

  upload(path: string): string {
    return path ? store.state.settings.Uploads + "/" + path : "";
  }

  uploads(paths: string[]): string[] {
    return paths.map((p) => this.upload(p));
  }

  toggleDay(day: any) {
    if (day.status === null) return this.save(() => GuidelineApi.record(this.d.id, day.date, DayDone), () => this.toggleDay(day));
    return this.undo(day.date);
  }

  // Done in a session: the confirmation and, below, what to send. Done on a guideline without sessions: to what it asks.
  async mark(status: number) {
    await this.save(() => GuidelineApi.record(this.d.id, this.today, status), () => this.mark(status));
    if (status !== DayDone || this.error) return;
    if (this.openSession) {
      this.justDone = true;
      this.answeredId = -1;
      window.scrollTo(0, 0);
    } else if (this.place(null) && this.place(null).canSend) {
      this.$router.push(this.wholeLink);
    }
  }

  undo(date: string) {
    return this.save(() => GuidelineApi.undo(this.d.id, date), () => this.undo(date));
  }

  retry() {
    const again = this.failed;
    this.error = "";
    this.failed = null;
    return again ? again() : Promise.resolve();
  }

  async save(call: () => Promise<any>, again: () => Promise<void>) {
    if (this.busy) return;
    this.busy = true;
    const res = await call().catch(() => null);
    if (!res || res.ok === false) {
      this.busy = false;
      this.failed = again;
      this.error = res && res.errorMsg ? res.errorMsg : this.$t("It was not saved.").toString();
      return;
    }
    this.error = "";
    this.failed = null;
    await this.load().catch(() => null);
    this.busy = false;
  }

  async load() {
    const data = await GuidelineApi.detail(this.$route.params.id, this.previewToken);
    this.d = data && data.ok ? data.model : null;
    this.loaded = true;
    if (this.d && !this.previewToken) await Promise.all([this.loadSubmissions(), this.loadTopics()]);
  }

  async loadTopics() {
    const res = await GuidelineApi.messageTopics();
    this.canMessage = !!res && res.ok && res.model.some((t: any) => t.customerGuidelineId === this.d.id);
    if (this.canMessage) return;
    const old = await GuidelineApi.messages(this.d.id);
    this.hasMessages = !!old && old.ok && old.model.length > 0;
  }

  async loadSubmissions() {
    const res = await GuidelineApi.submissions(this.$route.params.id);
    this.slots = res && res.ok && res.model ? res.model.slots : [];
    this.submissions = this.slots.filter((x: any) => x.canSend || x.submission);
  }

  // What the guideline (sessionId null) or one session asks the patient to send, with the last submission.
  place(sessionId: number | null): any {
    return this.submissions.find((x: any) => (x.sessionId || null) === sessionId) || null;
  }

  placeKey(sessionId: number | null): string {
    const p = this.place(sessionId);
    return `${sessionId || 0}-${p && p.submission ? p.submission.id : 0}`;
  }

  async mounted() {
    await this.load();
    if (!this.d) return;
    new SettingsService().setPageTitle(this.d.name);
  }
}
